import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { usePlanApp } from './hooks/usePlanApp';
import { AboutPage } from './pages/AboutPage';
import { AccessPage } from './pages/AccessPage';
import { DesignSystemPage } from './pages/DesignSystemPage';
import { LoginPage } from './pages/LoginPage';
import { PlanPage } from './pages/PlanPage';
import { ProfilePage } from './pages/ProfilePage';
export function App() {
    const plan = usePlanApp('editor', 'compact');
    useEffect(() => {
        document.body.classList.toggle('kp-screen-login', plan.state.screen === 'login');
    }, [plan.state.screen]);
    if (plan.state.screen === 'login') {
        return (_jsx(LoginPage, { showPw: plan.state.showPw, loginLoading: plan.state.loginLoading, loginError: plan.state.loginError, onTogglePw: plan.handlers.togglePw, onLoading: plan.handlers.setLoginLoading, onError: plan.handlers.setLoginError, onSuccess: plan.handlers.onLoginSuccess }));
    }
    if (plan.state.screen === 'profile') {
        return _jsx(ProfilePage, { plan: plan });
    }
    if (plan.state.screen === 'access') {
        return _jsx(AccessPage, { plan: plan });
    }
    if (plan.state.screen === 'about') {
        return _jsx(AboutPage, { plan: plan });
    }
    if (plan.state.screen === 'design-system') {
        return _jsx(DesignSystemPage, { plan: plan });
    }
    return _jsx(PlanPage, { plan: plan });
}
